import assessmentConf from './assessmentConf'
import assessmentRecord from './assessmentRecord'
import assessment from './assessment'
import assessmentVersion from "./assessmentVersion";
import addsubConf from "./addsubConf";
import addsubRecord from "./addsubRecord";
import capacity from "./capacity";

const AssessmentServer = {
    assessmentConf,
    assessment,
    assessmentRecord,
    assessmentVersion,
    addsubConf,
    addsubRecord,
    capacity,
};

export default AssessmentServer;
